export const WEATHER_ROUTING = [
  {
    path: '/weather.html',
    component: () =>
      import(/* webpackChunkName: "weather-page" */ './pages/weather.page')
  }
];
